
import 'slick-carousel';

class Carousel {
	constructor(wrapperElem, customSettings) {

		this._$wrapperElem = wrapperElem;

		this._videoHasEnded = true;
		this._$$slides = Array.from(wrapperElem.children);
		if (this.is_single_slide()) {
			this.loop_single_slide_video();
		} else {

			const settings = this.get_settings(customSettings, wrapperElem);
			this.$slick = $(wrapperElem).slick(settings);

			// Fix for slidesToScroll bug
			if (settings.slidesToScroll) {
				this.$slick.slick('slickSetOption', 'slidesToScroll', settings.slidesToScroll, true);
			}


			this.play_slide_video(0);
			this.$slick.on('afterChange', (event, slick, slideIndex) => {
				this.play_slide_video(slideIndex);
			})
			this.$slick.on('beforeChange', (event, slick, slideIndex) => {
				this.reset_slide_video(slideIndex);
			})
		}
	}

	get_settings(customSettings, wrapperElem) {
		const btn = (text, className) => `<button type="button" class="slick-${className}" title="Go to ${text} slide">
			<span class="sr-only">${text}</span>
		</button>`;

		var speed = $(wrapperElem).data("autoplayspeed");
		const default_settings = {
			autoplay: true,
			autoplaySpeed: speed > 1 ? speed : 5000,
			prevArrow: btn('Previous', 'prev'),
			nextArrow: btn('Next', 'next'),
		}
		return Object.assign(default_settings, customSettings);
	}

	get_slide(slide_index_or_elem) {
		return typeof slide_index_or_elem === 'number' ? this._$$slides[slide_index_or_elem] : slide_index_or_elem;
	}

	is_single_slide() {
		return (this._$$slides.length <= 1);
	}

	loop_single_slide_video() {
		if (this._$$slides.length <= 1) {
			const slideElem = this.get_slide(0);

			var checkExist = setInterval(function () {
				var video = slideElem.querySelector('video');
				if (video) {
					$(video).attr('loop', 'loop');
					clearInterval(checkExist);
				}
			}, 100); // check every 100ms
		}
	}

	play_slide_video(slide) {
		const slideElem = this.get_slide(slide);
		const video = slideElem.querySelector('video');
		if (video) {
			if (video.duration > 1) {
				this.$slick.slick('slickPause');
				var _this = this;
				this._videoHasEnded = false;
				video.onended = function () {
					video.pause();
					if (_this._videoHasEnded == false) {
						_this.$slick.slick('slickNext');
					}
				}

				video.currentTime = 0;
				// Code based on https://developers.google.com/web/updates/2017/06/play-request-was-interrupted
				var playPromise = video.play();

				if (playPromise !== undefined) {
					playPromise.then(_ => {
						// Automatic playback started!
					})
						.catch(error => {
							// Auto-play was prevented
							// Continue onto next slide							
							_this.$slick.slick('slickNext');
						});
				}
			}
		}
	}

	reset_slide_video(slide) {
		if (this._videoHasEnded == false) {
			this.$slick.slick('slickPlay');
			this._videoHasEnded = true;
		}
		const slideElem = this.get_slide(slide);
		const video = slideElem.querySelector('video');
		if (video) {
			if (video.duration > 1) {
				video.currentTime = 0;
			}
		}
	}
}

export default function () {
	// add the 'custom' class to a .carousel element to stop it from being initialised with these defaults and instead, initialise your carousel inside your own module's js passing in your custom settings to the constructor above
	$('.carousel:not(.custom)').each(function () {
		new Carousel(this);
	})
}

export { Carousel }
